import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@hooks/useAuth'
import Input from '@components/ui/Input'

export default function LoginPage() {
  const { login, isLoading } = useAuth()
  const navigate = useNavigate()
  const [form, setForm] = useState({ username: '', password: '' })
  const [error, setError] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [remember, setRemember] = useState(false)

  useEffect(() => {
    try {
      const cached = localStorage.getItem('bravo-login-cache')
      if (cached) {
        const parsed = JSON.parse(cached)
        setForm({ username: parsed.username || '', password: parsed.password || '' })
        setRemember(true)
      }
    } catch (err) {
      // ignore cache parse errors
    }
  }, [])

  const onSubmit = async (e) => {
    e.preventDefault()
    setError('')
    const result = await login(form.username.trim(), form.password)
    if (!result.success) {
      setError(result.error || 'Usuário/e-mail ou senha inválidos')
      return
    }
    if (remember) {
      localStorage.setItem('bravo-login-cache', JSON.stringify({ username: form.username, password: form.password }))
    } else {
      localStorage.removeItem('bravo-login-cache')
    }
    navigate('/')
  }

  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-large border border-gray-200 dark:border-gray-700 max-w-md">
      <div className="mb-4">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">Entrar</h2>
      </div>
      <form className="space-y-4" onSubmit={onSubmit}>
        <Input
          label="Usuario ou e-mail"
          placeholder="Digite seu usuario"
          value={form.username}
          onChange={(e) => setForm({ ...form, username: e.target.value })}
          required
          autoFocus
        />
        <div>
          <label className="block text-sm font-medium mb-1">Senha</label>
          <div className="relative">
            <Input
              type={showPassword ? 'text' : 'password'}
              className="pr-16"
              placeholder="Digite sua senha"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required
            />
            <button
              type="button"
              className="absolute right-2 top-1/2 -translate-y-1/2 text-sm text-gray-600 dark:text-gray-300 hover:underline"
              onClick={() => setShowPassword((v) => !v)}
            >
              {showPassword ? 'Ocultar' : 'Mostrar'}
            </button>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <input
            id="remember"
            type="checkbox"
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
          />
          <label htmlFor="remember" className="text-sm text-gray-700 dark:text-gray-300">
            Salvar usuario e senha neste dispositivo
          </label>
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button
          type="submit"
          disabled={isLoading}
          className="w-full bg-primary text-white py-2 rounded-md disabled:opacity-60"
        >
          {isLoading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  )
}
